import React from 'react';

type NativeTabFocusGateProps = {
  children: React.ReactNode;
};

export default function NativeTabFocusGate({ children }: NativeTabFocusGateProps) {
  return <>{children}</>;
}
